import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { allQuoteQuestionInfoMap } from '../constants/questions';
import { getLocalTranslation } from '../utils/i18nKit';
import { getGreatAmericanBusinessInsuranceQuoteQuestionInfoMap } from './questions/greatAmericanBusinessInsurance';
import { getHiscoxUSInsuranceQuoteQuestionInfoMap } from './questions/hiscoxUSInsurance';
export var getAllQuoteQuestionInfoMap = function getAllQuoteQuestionInfoMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, allQuoteQuestionInfoMap), getGreatAmericanBusinessInsuranceQuoteQuestionInfoMap()), getHiscoxUSInsuranceQuoteQuestionInfoMap()), {}, {
    git_move_goods_enter_house: {
      title: '',
      subTitle: "".concat($t('kit:git_move_goods_not_enter_house_question_1')),
      confirmType: '2',
      spec: [],
      reverse: true
    },
    git_move_goods_not_enter_house: {
      title: '',
      subTitle: "".concat($t('kit:git_move_goods_not_enter_house_question_1')),
      confirmType: '2',
      spec: []
    },
    question_good_in_transit_subcontract_out: {
      title: "".concat($t('kit:do_you_subcontract_out_more_than_25_percent_of_your_work'), "?"),
      confirmType: '2',
      spec: [],
      reverse: true
    },
    question_good_in_transit_hazardous_goods: {
      title: "".concat($t('kit:do_you_transport_hazardous_goods')),
      confirmType: '2',
      spec: [],
      reverse: true
    },
    question_good_in_transit_ADR_2019: {
      title: "".concat($t('kit:do_these_goods_exceed_limited_quantity_and_1000_point_rule_adr_2019'), "?"),
      confirmType: '2',
      spec: [],
      reverse: true
    },
    question_good_in_transit_couriers: {
      title: "".concat($t('kit:please_confirm_agree_or_disagree'), ":"),
      confirmType: '1',
      spec: [{
        list: [{
          text: "".concat($t('kit:do_not_undertake_house_office_removals'), ".")
        }, {
          text: "".concat($t('kit:do_not_transport_motorised_vehicles_livestock_perishable'), ".")
        }]
      }]
    },
    question_good_in_transit_removers: {
      title: "".concat($t('kit:please_confirm_agree_or_disagree'), ":"),
      confirmType: '1',
      spec: [{
        list: [{
          hideDot: true,
          text: "".concat($t('kit:do_not_transport_livestock_perishable'), ".")
        }]
      }]
    },
    question_good_in_transit_vehicle: {
      title: "".concat($t('kit:please_confirm_agree_or_disagree'), ":"),
      confirmType: '1',
      spec: [{
        list: [{
          text: "".concat($t('kit:do_not_transport_livestock_perishable'), ".")
        }, {
          text: "".concat($t('kit:only_transport_motorised_vehicles_by_trailer'), ".")
        }]
      }]
    },
    goods_in_transit_declaration_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: "".concat($t('kit:claims')),
        list: [{
          hideDot: true,
          text: "".concat($t('kit:no_claims_losses_incidents_last_5_years'))
        }]
      }, {
        text: "".concat($t('kit:convictions_ccjs_disqualifications')),
        list: [{
          text: "".concat($t('kit:charged_convicted_criminal_offence'))
        }, {
          text: "".concat($t('kit:subject_ccj_bankruptcy_insolvency_proceedings'))
        }, {
          text: "".concat($t('kit:disqualified_company_directors_disqualification_act'))
        }]
      }, {
        text: "".concat($t('kit:previous_insurance')),
        list: [{
          hideDot: true,
          text: "".concat($t('kit:never_declined_refused_insurance_cover'))
        }]
      }, {
        text: "".concat($t('kit:git.business_activities')),
        uniqueId: 'business-activities',
        list: [{
          text: "".concat($t('kit:git.broker_forwarder_limit'))
        }, {
          text: "".concat($t('kit:git.no_hazardous_goods_transport')),
          infoEvent: 'ADR_2019_ALERT_INFO'
        }]
      }, {
        text: "".concat($t('kit:my_work_vehicle')),
        uniqueId: 'vehicle-transportation',
        list: [{
          hideDot: true,
          text: "".concat($t('kit:vehicle_weighs_less_than_7_5_tonnes'))
        }]
      }]
    },
    accelerant_declaration_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:accelerant.confirm_no_risk_to_individuals_or_property'),
          list: [{
            text: $t('kit:accelerant.risk_harm_to_individuals')
          }, {
            text: $t('kit:accelerant.risk_damage_to_property')
          }]
        }, {
          text: $t('kit:accelerant.no_asbestos_or_pollution_advice')
        }, {
          text: $t('kit:accelerant.obtain_client_approval_before_implementation')
        }, {
          text: $t('kit:accelerant.do_not_offer_specific_services'),
          list: [{
            text: $t('kit:accelerant.accountancy_and_financial_auditing')
          }, {
            text: $t('kit:accelerant.valuation_mergers_acquisition')
          }, {
            text: $t('kit:accelerant.interim_c_level_placement')
          }, {
            text: $t('kit:accelerant.turnaround_restructuring_consultancy')
          }]
        }, {
          text: $t('kit:accelerant.not_responsible_for_executive_decisions')
        }]
      }]
    },
    accelerant_declaration_p2: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:accelerant.no_healthcare_financial_services')
        }, {
          text: $t('kit:accelerant.no_processing_of_sensitive_data')
        }, {
          text: $t('kit:accelerant.no_sla_breaches')
        }, {
          text: $t('kit:accelerant.no_regulated_professional_services')
        }, {
          text: $t('kit:accelerant.use_mfa_for_cloud_access')
        }, {
          text: $t('kit:accelerant.no_remote_access_without_vpn')
        }, {
          text: $t('kit:accelerant.regular_cybersecurity_training')
        }]
      }]
    },
    accelerant_declaration_p3: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:accelerant.no_sign_off_on_accounts_or_audits')
        }, {
          text: $t('kit:accelerant.no_tax_or_investment_advice')
        }]
      }]
    },
    accelerant_declaration_p4: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:accelerant.confirm_no_risk_to_individuals_or_property'),
          list: [{
            text: $t('kit:accelerant.risk_harm_to_individuals')
          }, {
            text: $t('kit:accelerant.risk_damage_to_property')
          }]
        }, {
          text: $t('kit:accelerant.obtain_client_approval_before_implementation')
        }]
      }]
    },
    accelerant_declaration_p5: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:accelerant.do_not_carry_out_installation')
        }, {
          text: $t('kit:accelerant.sub_contractors_have_own_insurance')
        }]
      }]
    },
    accelerant_declaration_p6: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: 'You DO NOT undertake any design, installation, retrofit works, construction, project management, structural surveys, property valuations, estate / letting agency or financial / investment advice.'
        }]
      }]
    },
    accelerant_generic_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.manual_work'),
        list: [{
          text: $t('kit:accelerant.less_than_25_percent_light_manual_work'),
          hideDot: true
        }]
      }, {
        text: '',
        list: [{
          text: $t('kit:accelerant.definition_of_heavy_manual_work'),
          hideDot: true
        }]
      }]
    },
    // Greate american
    greate_american_use_what_car: {
      title: $t('kit:greate_american.use_what_car'),
      subTitle: '',
      confirmType: '2',
      spec: []
    },
    greate_american_mixed_courier_work: {
      title: $t('kit:greate_american.mixed_courier_work'),
      subTitle: '',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    greate_american_subhauler: {
      title: $t('kit:greate_american.subhauler'),
      subTitle: '',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    greate_american_subhauler_indemnify: {
      title: $t('kit:greate_american.subhauler_indemnify'),
      subTitle: '',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    greate_american_cargo_loses: {
      title: $t('kit:greate_american.cargo_loses'),
      subTitle: '',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    greate_american_experience_carry_mixed_goods: {
      title: '',
      subTitle: $t('kit:greate_american.experience_carry_mixed_goods'),
      confirmType: '2',
      spec: []
    },
    greate_american_drivers_age_range: {
      title: $t('kit:greate_american.drivers_age_range'),
      confirmType: '2',
      spec: []
    },
    greate_american_drivers_age_range_acceptable_dot: {
      title: $t('kit:greate_american.drivers_age_range_acceptable_dot'),
      subTitle: '',
      confirmType: '2',
      spec: []
    },
    greate_american_refrigiration_year_experience: {
      title: $t('kit:greate_american.refrigiration_year_experience'),
      subTitle: '',
      confirmType: '2',
      spec: []
    },
    greate_american_refrigerated_equipment: {
      title: $t('kit:greate_american.refrigerated_equipment'),
      subTitle: '',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    greate_american_rigging_transporting_goods: {
      title: $t('kit:greate_american.rigging_transporting_goods'),
      subTitle: '',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    greate_american_acceptance_criteria: {
      title: $t('kit:greate_american.acceptance_criteria.title'),
      descTitle: $t('kit:greate_american.acceptance_criteria.desc_title'),
      confirmType: '1',
      spec: [{
        list: [{
          text: $t('kit:greate_american.acceptance_criteria.text_1'),
          showCheckbox: true,
          uniqueId: 'coverage_cancelled_or_non_renewed_in_last_5_years',
          checkedValue: true
        }, {
          text: $t('kit:greate_american.acceptance_criteria.text_2'),
          showCheckbox: true,
          uniqueId: 'current_carrier',
          checkedValue: true
        }]
      }]
    },
    greate_american_acceptance_criteria_different_name: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: $t('kit:greate_american.acceptance_criteria_different_name.text_1')
        }]
      }]
    },
    greate_american_declaration_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:greate_american.declaration_p1.spec_1_text'),
        list: [{
          hideDot: true,
          text: $t('kit:greate_american.declaration_p1.spec_1_list_text_1')
        }]
      }, {
        text: $t('kit:greate_american.declaration_p1.spec_2_text'),
        list: [{
          text: $t('kit:greate_american.declaration_p1.spec_2_list_text_1')
        }, {
          text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2'),
          list: [{
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_1')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_2')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_3')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_4')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_5')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_6')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_7')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_8')
          }, {
            text: $t('kit:greate_american.declaration_p1.spec_2_list_text_2_9')
          }]
        }, {
          text: $t('kit:greate_american.declaration_p1.spec_2_list_text_3')
        }, {
          text: $t('kit:greate_american.declaration_p1.spec_2_list_text_4')
        }, {
          text: $t('kit:greate_american.declaration_p1.spec_2_list_text_5')
        }, {
          text: $t('kit:greate_american.declaration_p1.spec_2_list_text_6')
        }, {
          text: $t('kit:greate_american.declaration_p1.spec_2_list_text_7')
        }]
      }]
    },
    user_confirm_received: {
      title: '',
      confirmType: '1',
      spec: [{
        text: '',
        list: [{
          text: $t('kit:greate_american.user_confirm_received'),
          hideDot: true
        }]
      }]
    },
    git_carry_large_heavy_items_premises: {
      title: '',
      subTitle: $t('kit:git_move_goods_not_enter_house_question_2'),
      confirmType: '2',
      spec: []
    },
    enter_customer_house: {
      title: "".concat($t('kit:greate_american.enter_customer_house_question_1')),
      subTitle: '',
      confirmType: '2',
      spec: []
    },
    enter_customer_house_carry_heavy_items: {
      title: "".concat($t('kit:greate_american.enter_customer_house_carry_heavy_items_question_1')),
      subTitle: '',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    placements_within_white_collar: {
      title: $t('kit:recruitment_question.temporary_placements_within_some_industries'),
      confirmType: '2',
      spec: []
    },
    great_american_fast_process_criteria: {
      title: '',
      confirmType: '1',
      spec: [{
        text: '',
        list: [{
          text: $t('kit:greate_american.fast_track.spec_1_list_text_1')
        }, {
          text: $t('kit:greate_american.fast_track.spec_1_list_text_2')
        }, {
          text: $t('kit:greate_american.fast_track.spec_1_list_text_3')
        }, {
          text: $t('kit:greate_american.fast_track.spec_1_list_text_4')
        }]
      }]
    },
    recruitment_declaration_p1: {
      title: '',
      confirmType: '1',
      spec: []
    },
    property_unoccupied_security_devices: {
      // title: $t('kit:property_secured_unoccupied'),
      title: 'When the property is unoccupied, are all external doors and windows closed and locked, with all security devices in operation?',
      confirmType: '2',
      spec: []
    },
    recruitment_property_security_measures: {
      // title: $t('kit:can_you_confirm_the_property_has_appropriate_security_measures'),
      // title:
      //   'Are all external doors secured by key-operated multi-point or deadlocking locks, and all accessible windows fitted with key-operated locks or equivalent security?',
      title: 'Can you confirm you have appropriate security measures in place at the property?',
      // descTitle: $t('kit:locks_bs3621_security'),
      descTitle: 'This may include secure door and window locks, an intruder alarm, or other physical or monitored security measures.',
      confirmType: '2',
      spec: []
    },
    recruitment_property_standard_construction_and_good_state: {
      title: $t('kit:property_standard_condition'),
      confirmType: '2',
      spec: []
    },
    recruitment_property_claims_last_5_years: {
      title: 'In the last 5 years, have the business suffered any loss, damage or made any claim relating to the property or its contents, whether insured or not?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    property_addtional_address: {
      title: $t('kit:do_you_require_cover_for_additional_address'),
      confirmType: '2',
      spec: [],
      reverse: true
    },
    recruitment_not_contractually_responsible: {
      title: $t('kit:not_liable_temp_staff'),
      descTitle: $t('kit:recruitment_liability_clause'),
      confirmType: '1',
      spec: []
    },
    great_american_business_insurance_declaration_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: '',
        list: [{
          text: $t('kit:no_fraud_conviction')
        }, {
          text: $t('kit:your_business_has_not_declared_bankruptcy_or_insolvency_in_the_last_5_years')
        }, {
          text: $t('kit:no_prohibited_services'),
          list: [{
            text: $t('kit:alcohol_tobacco_cannabis'),
            showBulletPoint: true
          }, {
            text: $t('kit:financial_insurance_legal'),
            showBulletPoint: true
          }, {
            text: $t('kit:architectural_engineering_construction'),
            showBulletPoint: true
          }, {
            text: $t('kit:aviation_maritime_trucking'),
            showBulletPoint: true
          }, {
            text: $t('kit:justice_law_enforcement'),
            showBulletPoint: true
          }, {
            text: $t('kit:environmental_hazmat'),
            showBulletPoint: true
          }, {
            text: $t('kit:healthcare_pharma'),
            showBulletPoint: true
          }, {
            text: $t('kit:gambling_lottery_sweepstakes'),
            showBulletPoint: true
          }, {
            text: $t('kit:pornography'),
            showBulletPoint: true
          }]
        }, {
          text: $t('kit:no_professional_services')
        }, {
          text: $t('kit:no_prohibited_services2')
        }, {
          text: $t('kit:we_have_disclosed_all_known_claims_and_circumstances_including_open_matters')
        }]
      }]
    },
    accelerant_estate_agents_declaration_1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:you_do_not_undertake_any_of_the_following_activities'),
          list: [{
            text: $t('kit:property_valuations')
          }, {
            text: $t('kit:investment_advice')
          }, {
            text: $t('kit:rics_surveyor_activities')
          }, {
            text: $t('kit:conveyancing_or_legal_services_of_any_description')
          }]
        }, {
          text: $t('kit:you_confirm_that'),
          list: [{
            text: $t('kit:any_valuations_provided_by_you_are'),
            list: [{
              text: $t('kit:for_marketing_purposes_only')
            }, {
              text: $t('kit:non_rics')
            }, {
              text: $t('kit:not_relied_upon_for_lending_insurance_taxation_or_investment_decisions')
            }, {
              text: $t('kit:stated_as_opinion_only')
            }]
          }, {
            text: $t('kit:client_money_segregated')
          }, {
            text: $t('kit:member_cmp_scheme')
          }, {
            text: $t('kit:member_deposit_scheme')
          }, {
            text: $t('kit:prescribed_info_tenants')
          }]
        }]
      }]
    },
    accelerant_r2r_scheme_declaration_1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:you_do_not_undertake_any_of_the_following_activities'),
          list: [{
            text: $t('kit:property_valuations')
          }, {
            text: $t('kit:investment_advice')
          }, {
            text: $t('kit:rics_surveyor_activities')
          }, {
            text: $t('kit:conveyancing_or_legal_services_of_any_description')
          }]
        }, {
          text: $t('kit:you_confirm_that'),
          list: [{
            text: $t('kit:any_valuations_provided_by_you_are'),
            list: [{
              text: $t('kit:for_marketing_purposes_only'),
              hideDot: true
            }, {
              text: $t('kit:non_rics'),
              hideDot: true
            }, {
              text: $t('kit:not_relied_upon_for_lending_insurance_taxation_or_investment_decisions'),
              hideDot: true
            }, {
              text: $t('kit:stated_as_opinion_only'),
              hideDot: true
            }]
          }, {
            text: $t('kit:client_money_segregated')
          }, {
            text: $t('kit:member_cmp_scheme')
          }, {
            text: $t('kit:member_deposit_scheme')
          }, {
            text: $t('kit:prescribed_info_tenants')
          }]
        }]
      }]
    },
    accelerant_accountants_declaration_1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:not_undertake_activities'),
          list: [{
            text: $t('kit:tax_efficient_schemes')
          }, {
            text: $t('kit:insolvency_services'),
            key: 'ACT049'
          }, {
            text: $t('kit:probate_estate_planning_wills_trusts_conveyancing_or_succession_planning'),
            key: 'ACT037'
          }, {
            text: $t('kit:mergers_acquisitions_disposals_or_corporate_finance_advisory_services'),
            key: 'ACT063'
          }, {
            text: $t('kit:financial_services_regulated')
          }, {
            text: $t('kit:fiduciary_role_excluding_admin'),
            key: 'ACT030'
          }, {
            text: $t('kit:service_regulated_firms')
          }, {
            text: $t('kit:providing_service_dpb_fca')
          }]
        }]
      }]
    },
    accelerant_accountants_declaration_2: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:not_undertake_activities'),
          list: [{
            text: $t('kit:tax_efficient_schemes')
          }, {
            text: $t('kit:insolvency_services'),
            key: 'ACT049'
          }, {
            text: $t('kit:probate_estate_planning_wills_trusts_conveyancing_or_succession_planning'),
            key: 'ACT037'
          }, {
            text: $t('kit:mergers_acquisitions_disposals_or_corporate_finance_advisory_services'),
            key: 'ACT063'
          }, {
            text: $t('kit:financial_services_regulated')
          }, {
            text: $t('kit:service_regulated_firms')
          }, {
            text: $t('kit:providing_service_dpb_fca')
          }]
        }]
      }]
    },
    accelerant_accountants_declaration_3: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:accelerant.general'),
        list: [{
          text: $t('kit:accelerant.no_professional_indemnity_claims_in_5_years')
        }, {
          text: $t('kit:accelerant.no_sanctioned_jurisdiction_services')
        }, {
          text: $t('kit:accelerant.no_criminal_offences_or_border_penalties')
        }]
      }, {
        text: $t('kit:accelerant.activities'),
        list: [{
          text: $t('kit:not_undertake_activities'),
          list: [{
            text: $t('kit:tax_efficient_schemes')
          }, {
            text: $t('kit:probate_estate_planning_wills_trusts_conveyancing_or_succession_planning'),
            key: 'ACT037'
          }, {
            text: $t('kit:financial_services_regulated')
          }, {
            text: $t('kit:service_regulated_firms')
          }, {
            text: $t('kit:providing_service_dpb_fca')
          }]
        }]
      }]
    },
    integrated_insurance_desk_scheme_acceptance: {
      confirmType: '1',
      spec: [{
        text: $t('kit:insurance_desk_property_uk'),
        list: [{
          text: $t('kit:your_expected_annual_turnover_does_not_exceed_250_000')
        }, {
          text: $t('kit:no_claims_losses')
        }, {
          text: $t('kit:no_bankruptcy_ccj')
        }, {
          text: $t('kit:rent_to_rent_principal')
        }]
      }]
    },
    broker_declaration_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:brokerDeclarations.claims'),
        list: [{
          hideDot: true,
          text: $t('kit:brokerDeclarations.declaration_p1_your_business_not_involved_in_losses')
        }]
      }, {
        text: $t('kit:brokerDeclarations.convictions_ccjs_disqualifications'),
        list: [{
          text: $t('kit:brokerDeclarations.declaration_p1_principals_not_convicted')
        }, {
          text: $t('kit:brokerDeclarations.declaration_p1_principals_not_bankrupt')
        }]
      }, {
        text: $t('kit:brokerDeclarations.previous_insurance'),
        list: [{
          text: $t('kit:brokerDeclarations.declaration_p1_never_declined_insurance')
        }, {
          text: $t('kit:brokerDeclarations.declaration_p1_not_aware_of_circumstances')
        }]
      }]
    },
    broker_declaration_directors_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:brokerDeclarations.material_facts'),
        list: [{
          text: $t('kit:brokerDeclarations.directors_p1_positive_net_worth')
        }, {
          text: $t('kit:brokerDeclarations.directors_p1_no_disqualified_officers')
        }, {
          text: $t('kit:brokerDeclarations.directors_p1_no_litigation')
        }, {
          text: $t('kit:brokerDeclarations.directors_p1_company_not_in_sectors'),
          list: [{
            text: $t('kit:brokerDeclarations.directors_p1_financial_sector')
          }, {
            text: $t('kit:brokerDeclarations.directors_p1_high_tech')
          }, {
            text: $t('kit:brokerDeclarations.directors_p1_legal_sector')
          }, {
            text: $t('kit:brokerDeclarations.directors_p1_professional_sports_clubs')
          }, {
            text: $t('kit:brokerDeclarations.directors_p1_speculative_exploration')
          }, {
            text: $t('kit:brokerDeclarations.directors_p1_bio_tech_company')
          }]
        }]
      }]
    },
    broker_declaration_employment_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:brokerDeclarations.material_facts'),
        list: [{
          text: $t('kit:brokerDeclarations.employment_p1_written_grievance_procedure')
        }, {
          text: $t('kit:brokerDeclarations.employment_p1_no_employee_layoffs')
        }, {
          text: $t('kit:brokerDeclarations.employment_p1_no_employees_in_usa')
        }]
      }]
    },
    broker_declaration_cyber_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          hideDot: true,
          text: $t('kit:brokerDeclarations.cyber_p1_website_not_critical')
        }]
      }]
    },
    broker_declaration_cyber_crime_p1: {
      title: '',
      confirmType: '1',
      spec: [{
        text: $t('kit:brokerDeclarations.material_facts'),
        list: [{
          text: $t('kit:brokerDeclarations.cyber_crime_p1_background_check_policy')
        }, {
          text: $t('kit:brokerDeclarations.cyber_crime_p1_stock_check')
        }, {
          text: $t('kit:brokerDeclarations.cyber_crime_p1_vetting_suppliers')
        }, {
          text: $t('kit:brokerDeclarations.cyber_crime_p1_dual_control_payments')
        }, {
          text: $t('kit:brokerDeclarations.cyber_crime_p1_finance_consolidation')
        }]
      }]
    },
    question_good_in_transit_vehicle_and_removers: {
      title: $t('kit:please_confirm_agree_or_disagree'),
      confirmType: '1',
      spec: [{
        list: [{
          text: $t('kit:goods_in_transit_vehicle_and_removers.statement_1')
        }, {
          text: $t('kit:goods_in_transit_vehicle_and_removers.statement_2')
        }, {
          text: $t('kit:goods_in_transit_vehicle_and_removers.statement_3')
        }]
      }]
    }
  });
};